import React from "react"
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Footer from "../../pages/Footer";
import Home from "../../pages/Home";
import Blog from "./pages/Blog";
import ExampleBlog1 from "./pages/blog_content/ExampleBlog1";
import { Helmet } from "react-helmet";
import SEO from "../../SEO/SEO";

function AppBlog() {
  return (
    <div className="app-blog" id="rekanata-blog">
      <SEO
        title="Blog Pembangunan dan Desain Profesional oleh Rekanata Konstruksi - Rumah, Gedung, Kantor, Komersial, Perumahan, Lapangan, Landscape, dan Fasilitas Khusus"
        description="Blog Rekanata Konstruksi memberikan wawasan mendalam mengenai layanan pembangunan profesional, mulai dari rumah, gedung, kantor, perumahan, hingga pembangunan komersial, lapangan, desain landscape, dan fasilitas khusus. Kami juga melayani renovasi bangunan, desain interior, serta konstruksi masjid dengan kualitas terbaik. Dapatkan solusi konstruksi inovatif untuk proyek perumahan, kantor, taman, lapangan olahraga, dan berbagai fasilitas publik lainnya. Rekanata Konstruksi menyediakan layanan desain gratis untuk proyek Anda dengan pendekatan yang efisien dan sesuai anggaran."
        canonical="https://rekanata.com/blog"
        metaKeywords="pembangunan rumah, pembangunan gedung, konstruksi kantor, pembangunan komersial, perumahan, desain landscape, pembangunan lapangan, renovasi bangunan, desain interior, konstruksi masjid, desain rumah, desain kantor, arsitektur gedung, fasilitas khusus, solusi konstruksi efisien, layanan renovasi, desain taman, lapangan olahraga, pembangunan fasilitas publik, desain gratis"
      // Tidak perlu menambahkan metaKeywords di sini. Jika tidak diisi, fallback default akan digunakan. 
      // Jika Anda mengisi nilai di sini, maka nilai yang dituliskan di properti ini yang akan digunakan.
      />

      <div><Blog /></div>
      <div><Footer /></div>
    </div>
  )
}

export default AppBlog;